import React, {Component} from 'react';
import PropTypes from 'prop-types';
import md5 from 'md5';

import {DEFAULT_SIZE_AVATAR, DOUBLE, INIT_INDEX} from 'util/constants';
import {getColorIndex} from 'util/utils';

import 'style/components/user/user-avatar.scss';

const DEFAULT_AVATAR = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNcVA8AAckBI7zuPHQAAAAASUVORK5CYII=';
const
    NUM_INITIALS = 3,
    TEXT_PERC = 2.3;
/**
 * Returns a full name concatenating both of names or just the first name
 * @param {string} firstName The first or only name to show
 * @param {string} lastName A possible second name to show
 * @returns {string} The final text to show
 */
const _getDisplayName = (firstName, lastName) => `${firstName}${lastName ? ` ${lastName}` : ''}`;
/**
 * Create the url for gravatar
 * @param {string} email The email for getting the url
 * @returns {string} The gravatar url
 */
const _createGravatarUrl = email => `https://www.gravatar.com/avatar/${md5(email)}?d=404`;
/**
 * Generate de class name for the svg
 * @param {number} index The index for the svg class
 * @param {string} className A default className
 * @returns {string} The class for svg
 */
const _getClassName = (index, className) => `user-avatar img-circle svg-color-${index} ${className}`;

/* Component to render the user avatar */
class UserAvatar extends Component {

    static propTypes = {
        firstName: PropTypes.string, // The first name of the user
        lastName:  PropTypes.string, // The last name of the user
        email:     PropTypes.string, // The email of the user
        size:      PropTypes.number, // The size for the avatar
        className: PropTypes.string // The class name for the avatar
    };
    static defaultProps = {
        email:     `${Date.now()}`,
        size:      DEFAULT_SIZE_AVATAR,
        className: ''
    };

    state = {
        badGravatar: false // If the gravatar was not exist
    };

    /**
     * Init state
     */
    componentWillMount() {
        this.handleImageError = this.handleImageError.bind(this);
    }

    /**
     * Set as bad gravatar when there is no email
     */
    componentWillReceiveProps(nextProps) {
        const {email} = this.props;

        email !== nextProps.email && this.setState({
            badGravatar: false
        });
    }

    /**
     * Handle when the gravatar sends an error
     */
    handleImageError() {
        this.setState({
            badGravatar: true
        });
    }

    renderSvg(title) {
        const
            {size, className} = this.props;

        const
            colourIndex = getColorIndex(title),
            svgClass = _getClassName(colourIndex, className),
            initials = title
                .toLowerCase()
                .split(' ')
                .slice(INIT_INDEX,NUM_INITIALS)
                .map(part => part.charAt(INIT_INDEX))
                .join('');

        return (
            <svg width={size} height={size} className={svgClass}>
                <circle cx={size / DOUBLE} cy={size / DOUBLE} r={size / DOUBLE} />
                <text
                    x="50%"
                    y="50%"
                    fontFamily="Rubik-Medium"
                    fontSize={Math.round(size / TEXT_PERC)}
                    textAnchor="middle"
                    alignmentBaseline="central"
                >
                    {initials}
                </text>
            </svg>
        );
    }


    renderImg(src, title) {
        const {size, className} = this.props;

        return (
            <img
                ref="img"
                className={`user-avatar img-circle ${className || ''}`}
                height={size}
                width={size}
                src={src}
                alt={title}
                title={title}
                onError={this.handleImageError}
            />
        );
    }

    render() {
        const
            {firstName, lastName, email} = this.props,
            {badGravatar} = this.state,
            title = _getDisplayName(firstName, lastName);

        return badGravatar ?
            title ? this.renderSvg(title) : this.renderImg(DEFAULT_AVATAR, title) :
            this.renderImg(_createGravatarUrl(email), title);
    }
}

export default UserAvatar;



// WEBPACK FOOTER //
// ./src/components/user/UserAvatar.jsx